import { Box, Button, Typography } from "@mui/material";
import ChatInput from "./chat-input";
import { PROMPT_SUGGESTIONS } from "@/constants/copilot";

const EmptyState = ({
  setUserPrompt,
  userPrompt,
  handlePromptChange,
  fileStates,
  handleSendUserQuery,
  additionalPrompt,
  setAdditionalPrompt,
  selectedSource,
  setSelectedSource,
  chatLoading,
  stopChat,
  fileInputRef,
  handleFileSelect,
  setFileStates,
  setFileError,
  systemPrompt,
  setSystemPrompt,
  handleSystemPromptUpdate,
  additionalPromptOpen,
  setAdditionalPromptOpen,
}: any) => (
  <Box
    sx={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      minHeight: "100vh",
      px: 2,
    }}
  >
    <Typography
      variant="h1"
      fontWeight="bold"
      mb={2}
      data-testid="copilot-heading"
    >
      Assistant
    </Typography>
    <Box
      sx={{
        display: "flex",
        gap: 2,
        mb: 4,
        flexWrap: "wrap",
        justifyContent: "center",
      }}
    >
      {PROMPT_SUGGESTIONS?.map((suggestion, index) => (
        <Button
          sx={{
            fontWeight: "600",
            fontSize: "1rem",
            textTransform: "none",
          }}
          key={index}
          variant="outlined"
          onClick={() => {
            setUserPrompt(suggestion?.prompt);
            handleSendUserQuery(suggestion?.prompt);
          }}
        >
          {suggestion?.title}
        </Button>
      ))}
    </Box>

    <ChatInput
        userPrompt={userPrompt}
        handlePromptChange={handlePromptChange}
        setUserPrompt={setUserPrompt}
        fileStates={fileStates}
        handleSendUserQuery={handleSendUserQuery}
        additionalPrompt={additionalPrompt}
        setAdditionalPrompt={setAdditionalPrompt}
        selectedSource={selectedSource}
        setSelectedSource={setSelectedSource}
        chatLoading={chatLoading}
        stopChat={stopChat}
        fileInputRef={fileInputRef}
        handleFileSelect={handleFileSelect}
        setFileStates={setFileStates}
        fileError={""}
        setFileError={setFileError}
        systemPrompt={systemPrompt}
        setSystemPrompt={setSystemPrompt}
        additionalPromptOpen={additionalPromptOpen}
        setAdditionalPromptOpen={setAdditionalPromptOpen}
      />
    <div className="relative w-full px-2 py-2 text-center text-xs text-token-text-secondary empty:hidden md:px-[3.75rem]">
      This is AI generated content that requires human intervention. Review for
      accuracy and relevance.
    </div>
  </Box>
);

export default EmptyState;